import { render, staticRenderFns } from "./add-position.vue?vue&type=template&id=2525dd4e&scoped=true&"
import script from "./add-position.vue?vue&type=script&lang=js&"
export * from "./add-position.vue?vue&type=script&lang=js&"
import style0 from "./add-position.vue?vue&type=style&index=0&id=2525dd4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525dd4e",
  null
  
)

export default component.exports